import { useMemo } from 'react';
import { useApiQuery } from 'mf_core/query';

export function useUserActivity(enabled = false) {
  const query = useApiQuery<UserActivityResponseTO>(
    '/cms.webapi.digitalmarketing/cms/v1/user-info/getuseractivity',
    undefined,
    {
      enabled,
      refetchOnWindowFocus: false,
    }
  );
  return useMemo(() => {
    if (query.data) {
      const userActivityObject = {} as UserActivityCompatibleTO;
      Object.keys(DEFAULT_TEMPLATE).forEach((propertyName) => {
        const key = propertyName as keyof UserActivityTO;
        userActivityObject[key] = query.data[key] ?? DEFAULT_TEMPLATE[key];
      });
      return userActivityObject as UserActivityTO;
    }
    return DEFAULT_TEMPLATE;
  }, [query.data]);
}

export type UserActivityTO = {
  hasPlacedOrderCount: number;
  orderTrackingPageVisits: number;
  quotesCreatedCount: number;
  returnsPlacedUserCount: number;
  subscriptionPageVisits: number;
};

type UserActivityResponseTO = UserActivityTO & {
  loginCount: number;
  resellerId: string;
};
type UserActivityCompatibleTO = Record<keyof UserActivityTO, number>;

/** To ensure that UserActivity object does not pass unexpected properties */
const DEFAULT_TEMPLATE: UserActivityTO = {
  hasPlacedOrderCount: 0,
  orderTrackingPageVisits: 0,
  quotesCreatedCount: 0,
  returnsPlacedUserCount: 0,
  subscriptionPageVisits: 0,
};
